<div class="col">
    <div class="row justify-content-center shipping-payment-information in-one-line">
        <div class="col-12 col-md-6 col-lg-5">
            <div class="row">
                <div class="col-12 col-md-3 right nopadding"><img class="free"
                                                                  src="./assets/design/icons/free.svg" alt="">
                </div>
                <div class="col-12 col-md-9"><p class="txt">Eine Gratisprobe<br>bei jeder Bestellung!</p></div>
            </div>
        </div>
        <div class="col-12 col-md-6 col-lg-4">
            <div class="row">
                <div class="col-12 col-md-4 right nopadding"><img class="shipping"
                                                                  src="./assets/design/icons/shipping.svg" alt="">
                </div>
                <div class="col-12 col-md-8"><p class="txt">Versandkostenfrei<br>ab 150 €!*<br><span class="small"
                                                                                                     style="float:left;">*gilt nur für Privatkunden<br>&nbsp;Versand generell nur innerhalb Deutschlands </span>
                </p></div>
            </div>
        </div>
        <div class="col-12 col-md-auto col-lg-3 payment-methods">
            <div class="row">
                <div class="col-12 col-md-5 right nopadding">
                    <img class="paypal" src="./assets/design/paypal.jpg" alt=""><br>
                    <img class="paypal mb-2" src="./assets/design/klarna.png" alt=""><br>
                    <img class="creditcard"    src="./assets/design/creditcard.jpg" alt=""><br>
                    <img class="paypal" src="./assets/design/a-g-pay.png" alt="">
                </div>
                <div class="col-12 col-md-7"><p class="txt payment-methods">sowie Rechnung, Lastschrift<br>und
                    Vorauszahlung</p></div>
            </div>
        </div>
    </div>
</div>
